export default __webpack_public_path__ + "static/media/003-taxi.e0368ddd.png";